import { QueryParameterSchema } from './types';

export const statusFilterQueryFilter: QueryParameterSchema<'status'> = {
  getDefaultValue: () => '',
  getValue: ({ queryParameters }) => queryParameters.status,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    status: urlSearchParams.get('filter[status]') ?? '',
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[status]': value }),
  toSearchQuery: ({ value }) => {
    if (!value || value.length === 0) return {};
    return { 'filter[status]': value || '' };
  },
  sanitize: ({ value }) => {
    return { status: value };
  },
  getSummaryItems: ({ value }) => {
    return value
      ? [
          {
            filterKey: 'status',
            key: `status_${value}`,
            label: value,
            value: value,
          },
        ]
      : [];
  },
  removeParam: () => {
    return { status: undefined };
  },
};
